"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Calendly_1 = __importDefault(require("../contact/Calendly"));
var elements_1 = require("../elements");
var Footer_1 = __importDefault(require("../footer/Footer"));
var helpers_1 = require("../helpers");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var __1 = require("..");
var sections_1 = require("./sections");
var entryPoint = '';
var LocationListener = function (_a) {
    var onChange = _a.onChange;
    var location = react_router_dom_1.useLocation();
    react_1.useEffect(function () {
        if (!entryPoint) {
            entryPoint = location.pathname;
        }
        onChange(location);
    }, [location, onChange]);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
var canShowBeforeYouGo = false;
var beforeYouGoOpened = false;
var ContentRenderer = function (_a) {
    var _b, _c, _d, _e;
    var content = _a.content;
    var _f = react_1.useState(), locationState = _f[0], setLocationState = _f[1];
    var _g = react_1.useState(false), calendlyOpen = _g[0], setCalendlyOpen = _g[1];
    var _h = react_1.useState(false), beforeYouGoOpen = _h[0], setBeforeYouGoOpen = _h[1];
    var ctaClicked = function () {
        setCalendlyOpen(true);
    };
    var onBeforeYouGoConfirm = function () {
        setBeforeYouGoOpen(false);
        setTimeout(function () {
            setCalendlyOpen(true);
        }, 0);
    };
    var handleMouseLeave = react_1.useCallback(function () {
        if (!beforeYouGoOpened && canShowBeforeYouGo) {
            beforeYouGoOpened = true;
            setBeforeYouGoOpen(true);
        }
    }, []);
    react_1.useEffect(function () {
        setTimeout(function () {
            canShowBeforeYouGo = true;
        }, 10000);
    }, []);
    react_1.useEffect(function () {
        if (!calendlyOpen) {
            var dankePage = content.pages.find(function (page) { return page.id === 'Danke'; });
            if ((locationState === null || locationState === void 0 ? void 0 : locationState.pathname) !== (dankePage === null || dankePage === void 0 ? void 0 : dankePage.path)) {
                document.addEventListener('mouseleave', handleMouseLeave);
            }
            else {
                document.removeEventListener('mouseleave', handleMouseLeave);
                beforeYouGoOpened = true;
            }
        }
        else {
            document.removeEventListener('mouseleave', handleMouseLeave);
        }
    }, [calendlyOpen, locationState, content.pages, handleMouseLeave]);
    var linkTo = content.footer.linkTo || entryPoint;
    var getFooterLinks = function (content) {
        if (content.footer.links) {
            var result_1 = [];
            result_1.push({
                config: {
                    exact: true
                },
                title: 'Startseite',
                to: content.footer.links.some(function (link) { return link.to === linkTo; })
                    ? '/'
                    : linkTo
            });
            content.footer.links.forEach(function (link, index) {
                result_1.push({
                    config: {
                        exact: true
                    },
                    title: link.title,
                    to: link.to
                });
            });
            return result_1;
        }
        return __spreadArrays(((locationState === null || locationState === void 0 ? void 0 : locationState.pathname) !== linkTo
            ? [
                {
                    config: {
                        exact: true
                    },
                    title: 'Startseite',
                    to: linkTo
                }
            ]
            : []), [
            {
                title: 'Impressum',
                to: '/impressum'
            },
            {
                title: 'Datenschutz',
                to: '/datenschutz'
            }
        ]);
    };
    return (react_1.default.createElement(helpers_1.Provider, { gtmId: (_b = content === null || content === void 0 ? void 0 : content.config) === null || _b === void 0 ? void 0 : _b.gtmID, theme: (_c = content === null || content === void 0 ? void 0 : content.config) === null || _c === void 0 ? void 0 : _c.theme },
        react_1.default.createElement(LocationListener, { onChange: function (l) { return setLocationState(l); } }),
        !((_d = content === null || content === void 0 ? void 0 : content.config) === null || _d === void 0 ? void 0 : _d.disableDynamicScrollToTop) && react_1.default.createElement(helpers_1.DynamicScrollToTop, null),
        (content === null || content === void 0 ? void 0 : content.scrollToTop) && react_1.default.createElement(helpers_1.ScrollToTop, __assign({}, content.scrollToTop)),
        react_1.default.createElement(react_router_dom_1.Switch, null,
            content.pages.map(function (page, key) {
                var header = (react_1.default.createElement(__1.Header, __assign({ key: 'header-default-' + key, onCTAClick: ctaClicked }, content.header, page.headerConfig)));
                if (page.sections) {
                    return (react_1.default.createElement(react_router_dom_1.Route, { key: key, path: page.path, exact: true },
                        page.seoHeaderConfig && (react_1.default.createElement(helpers_1.SEOHeader, __assign({}, page.seoHeaderConfig))),
                        page.headerEnabled && header,
                        sections_1.sections(page, ctaClicked)));
                }
                else if (page.component) {
                    return (react_1.default.createElement(react_router_dom_1.Route, { key: key, path: page.path, exact: true },
                        page.seoHeaderConfig && (react_1.default.createElement(helpers_1.SEOHeader, __assign({}, page.seoHeaderConfig))),
                        page.headerEnabled && header,
                        react_1.default.createElement(page.component, __assign({}, page.data, { ctaClicked: ctaClicked }))));
                }
                return null;
            }),
            react_1.default.createElement(react_router_dom_1.Route, { path: "*" },
                react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" }))),
        react_1.default.createElement(Footer_1.default, __assign({}, content.footer, { linkTo: linkTo, links: getFooterLinks(content) })),
        !((_e = content === null || content === void 0 ? void 0 : content.calendly) === null || _e === void 0 ? void 0 : _e.isPage) && (react_1.default.createElement(Calendly_1.default, __assign({}, content.calendly, { showModal: calendlyOpen, closeModal: function () { return setCalendlyOpen(false); } }))),
        content.beforeYouGo && (react_1.default.createElement(elements_1.BeforeYouGo, __assign({}, content.beforeYouGo, { showModal: beforeYouGoOpen, onConfirm: onBeforeYouGoConfirm, closeModal: function () { return setBeforeYouGoOpen(false); } })))));
};
exports.default = ContentRenderer;
//# sourceMappingURL=ContentRenderer.js.map